var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-page',{attrs:{"id":"apply-password-reset-done"}},[_c('navbar',{attrs:{"title":"パスワード再設定の反映"}}),_c('background',[_c('div',{staticClass:"label-area"},[_c('p',{staticClass:"title"},[_vm._v("パスワードを再設定しました。")]),_c('p',[_vm._v("再設定したパスワードでログインしてください。")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }